import React, { useEffect, useRef } from "react";
import "./Skills.css";
import Reveal from "../../components/reveal/Reveal";
import ScrollWords from "../../components/scrollWords/ScrollWords";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import { skills } from "../../portfolio";
import { gsap, prefersReducedMotion } from "../../utils/gsap";

const clean = (s) => s.replace(/^[^\w]+/, "").trim();

export default function Skills() {
  const root = useRef(null);

  useEffect(() => {
    if (prefersReducedMotion()) return undefined;
    const ctx = gsap.context(() => {
      // heading words light up as the heading scrolls through the viewport
      gsap.fromTo(
        ".skills-section .sw",
        { opacity: 0.12, y: 18 },
        {
          opacity: 1,
          y: 0,
          stagger: 0.1,
          ease: "none",
          scrollTrigger: {
            trigger: ".skills-section .section-title",
            start: "top 88%",
            end: "bottom 55%",
            scrub: true,
          },
        }
      );

      gsap.utils.toArray(".cap-card").forEach((card) => {
        const st = {
          trigger: card,
          start: "top 78%",
          toggleActions: "play none none reverse",
        };
        gsap.from(card.querySelectorAll(".cap-list li"), {
          x: -26,
          opacity: 0,
          duration: 0.7,
          stagger: 0.12,
          ease: "power3.out",
          scrollTrigger: st,
        });
        gsap.from(card.querySelectorAll(".software-skill-inline"), {
          scale: 0,
          opacity: 0,
          duration: 0.5,
          stagger: 0.05,
          ease: "back.out(2.2)",
          scrollTrigger: st,
        });
        gsap.to(card.querySelector(".cap-num"), {
          y: -26,
          ease: "none",
          scrollTrigger: {
            trigger: card,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        });
      });
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section className="skills-section" id="skills" ref={root}>
      <div className="section-inner">
        <Reveal>
          <div className="section-head">
            <span className="section-kicker">What I do</span>
            <h2 className="section-title">
              <ScrollWords
                lines={[
                  "End-to-end capabilities,",
                  "from interface to infrastructure.",
                ]}
              />
            </h2>
          </div>
        </Reveal>

        <div className="cap-grid">
          {skills.data.map((group, i) => (
            <Reveal key={group.title} delay={i * 120} className="reveal-fill">
              <article className="cap-card">
                <div className="cap-top">
                  <span className="cap-num">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="cap-title">{group.title}</h3>
                </div>
                <ul className="cap-list">
                  {group.skills.map((line) => (
                    <li key={line}>{clean(line)}</li>
                  ))}
                </ul>
                <div className="cap-stack">
                  <SoftwareSkill logos={group.softwareSkills} />
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
